/**
 * The starting points offered on an empty Weave conversation.
 *
 * MOVED HERE, NOT COPIED. This list was a file-local `SAMPLE_PROMPTS` inside `ResultColumn` — the
 * legacy answer column — and the v1 conversation needed the same four. Two copies of the product's
 * suggested questions would drift the day anyone edited one, so the list moved to the constants
 * module both surfaces already read from and neither owns it now.
 *
 * `lane` is a plain-words tag for the kind of request ("Question", "Change"), display copy only. It
 * used to carry routing words ("Quick", "Risk audit") that no reader could act on.
 *
 * `prompt` is what a click puts in the composer when it differs from the visible `title`.
 */
export interface StarterPrompt {
  title: string;
  lane: string;
  prompt?: string;
}

export const SAMPLE_PROMPTS: readonly StarterPrompt[] = [
  { title: "What are the most complex classes in this org?", lane: "Question" },
  { title: "Which automation runs on every Lead creation?", lane: "Question" },
  { title: "Audit risk in this org's data model", lane: "Question" },
  { title: "Find untested Apex with high call volume", lane: "Question" },
  { title: "Describe a change", lane: "Change", prompt: "I want to change something in my org: " },
];

/** What clicking a starter puts in the composer. */
export function starterFill(starter: StarterPrompt): string {
  return starter.prompt ?? starter.title;
}
